import makeStyles from '@material-ui/core/styles/makeStyles';
import green from '@material-ui/core/colors/green';

export default makeStyles(theme => ({
  progressBar: {
    height: 15,
    backgroundColor: 'transparent',
    borderRadius: 5,
  },
  successColor: {
    backgroundColor: green[300],
  },
  errorColor: {
    backgroundColor: theme.palette.error.main,
  },
  showDetails: {
    transform: 'rotate(180deg)',
  },
  uploadWrapper: {
    maxHeight: 300,
    overflow: 'auto',
  },
  successColorText:{
    color: green[300]
  }
}));
